import React from 'react'

export default function ArrowDownFilledIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='7'
      height='4'
      viewBox='0 0 7 4'
      fill='none'
      {...props}
    >
      <path d='M0.375 0.25L3.5 3.375L6.625 0.25H0.375Z' fill='currentColor' />
    </svg>
  )
}
